<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 10px 0">
          <el-input v-model="serchat" placeholder="请输入客户名称" maxlength="30" style="width: 150px;"></el-input>
          <el-date-picker
            v-model="time"
            type="daterange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-dropdown split-button type="primary" @command="commandEvent">
            <span v-html="dropdownTitle"></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="全部">全部</el-dropdown-item>
              <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="isAjax" plain>查询</el-button>&nbsp;&nbsp;|
          <el-button type="primary" @click="excelData" plain>导出</el-button>
          <el-button circle @click="qieFun"><el-image :src="qiehuanIcon" style="width: 20px;height: 20px;vertical-align: middle;"></el-image></el-button>
          <div style="float: right;">
            <el-button :type="checkButtom1" @click="qie(1)" icon="el-icon-s-unfold" plain>表格</el-button>
<!--            <el-button :type="checkButtom2" @click="qie(2)" icon="el-icon-s-data" plain>图形</el-button>-->
          </div>
        </div>

      </el-header>
      <el-main :style="tableBlock">
        <template>
          <el-table
            :data="tableData"
            show-summary
            :summary-method="getSummaries"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="customerName"
              label="名称"
              width="150">
            </el-table-column>
            <!--<el-table-column
              prop="class"
              label="客户分类"
              width="120">
            </el-table-column>-->
            <el-table-column
              prop="order_total"
              sortable
              :sort-method="(a, b)=>{return a.order_total - b.order_total }"
              :formatter="formatterAmount"
              label="订单总金额"
              width="150">
            </el-table-column>
            <el-table-column
              prop="order_amount"
              sortable
              :sort-method="(a, b)=>{return a.order_amount - b.order_amount }"
              :formatter="formatterAmount"
              label="订单成交金额"
              width="150">
            </el-table-column>
            <el-table-column
              prop="order_number"
              sortable
              :formatter="formatterAmount"
              label="订单总数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="prescription_order_number"
              sortable
              :formatter="formatterAmount"
              label="处方单数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="shopping_order_number"
              sortable
              :formatter="formatterAmount"
              label="商城订单数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="store_number"
              sortable
              label="门店数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="member_number"
              sortable
              :formatter="formatterAmount"
              label="会员数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="doctor_number"
              sortable
              :formatter="formatterAmount"
              label="医生数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="patient_number"
              sortable
              :formatter="formatterAmount"
              label="患者数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="commodity_number"
              sortable
              :formatter="formatterAmount"
              label="商品数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="place_number"
              sortable
              :formatter="formatterAmount"
              label="下单客户数"
              width="150">
            </el-table-column>
            <el-table-column
              prop="member_add_number"
              sortable
              :formatter="formatterAmount"
              label="新增会员数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="doctor_add_number"
              sortable
              :formatter="formatterAmount"
              label="新增医生数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="patient_add_number"
              sortable
              :formatter="formatterAmount"
              label="新增患者数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="store_add_number"
              sortable
              label="新增门店数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="fan_number"
              sortable
              label="粉丝新增数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="cancel_fan_number"
              sortable
              label="粉丝取消关注数量"
              width="150">
            </el-table-column>
            <el-table-column
              prop="identification"
              label="标识"
              width="80">
            </el-table-column>
            <el-table-column
              prop="data_time"
              fixed="right"
              label="统计时间"
              width="200">
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-main :style="graphicalBlock" v-cloak>
        <div style="width: 100%;">
          <div id="myChart_all" :style="myChartdivHeight">
          </div>
          <div id="myChart_bottom" :style="myChartdivHeight">
          </div>
        </div>
      </el-main>
      <el-footer :style="tableBlock">
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import PurplePassion from '@/assets/purplePassion.js'
  export default {
    data () {
      return {
        qiehuanIcon: require('@/assets/qiehuan.png'),
        numtype: 'NUM',
        serchat:"",
        time:"",
        dropdownTitle:"请选择",
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        divHeight:500,
        myChartdivHeight:{
          width: '100%', height: '315px',float:'left'
        },
        dropdownList:[],
        checkButtom1:"primary",
        checkButtom2:"info",
        tableBlock:{
          display:'block'
        },
        graphicalBlock:{
          display:'block'
        },
        myChart_all:null,
        myChart_bottom:null,
        orderNumber:[],
        orderSales:[],
        orderDeal:[],
        placeNumber:[],
        member_number: [],
        doctor_number: [],
        patient_number: [],
        dataTime:[],
        gDataList:[],
        checkNum:1
      }
    },
    methods:{
      formatterAmount(row, column, cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            if (parseFloat(cellValue) > 9999) {
              const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
              let num = Math.abs(cellValue);
              const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
              const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
              return result;
            } else {
              return cellValue
            }
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatterAmount1(cellValue) {
        if (cellValue) {
          cellValue = parseFloat(cellValue).toFixed(2)
          cellValue = parseFloat(cellValue)
          if (this.$store.getters.getStoreNumtype === 'CN') {
            const units = ['', '万', '亿', '十亿', '百亿', '千亿'];
            let num = Math.abs(cellValue);
            const uIndex = Math.floor(Math.log10(num) / 4); // 计算所使用的单位
            const result = (cellValue / Math.pow(10, 4 * uIndex)).toFixed(2) + units[uIndex];
            return cellValue <= 0 ? 0 : result;
          } else {
            return cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        } else {
          return 0
        }
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy年MM月dd日";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      qie(val){
        if(val == 1){
          this.checkButtom1 = "primary";
          this.checkButtom2 = "info";
          this.graphicalBlock.display = 'none';
          this.tableBlock.display = 'block';
        }else{
          this.checkButtom2 = "primary";
          this.checkButtom1 = "info";
          this.tableBlock.display = 'none';
          this.graphicalBlock.display = 'block';
        }
        this.checkNum = val;
      },
      showGraphical(){
        this.orderNumber = [];
        this.orderSales = [];
        this.orderDeal = [];
        this.placeNumber = [];
        this.member_add_number = [];
        this.doctor_add_number = [];
        this.patient_add_number = [];
        this.store_add_number = [];
        this.dataTime = [];

        for(var i=0;i<this.gDataList.length;i++){
          this.orderNumber.push(this.gDataList[i].order_number)
          this.placeNumber.push(this.gDataList[i].place_number)
          this.member_add_number.push(this.gDataList[i].member_add_number)
          this.doctor_add_number.push(this.gDataList[i].doctor_add_number)
          this.patient_add_number.push(this.gDataList[i].patient_add_number)
          this.store_add_number.push(this.gDataList[i].store_add_number)
          var _a_ = parseFloat(this.gDataList[i].order_total).toFixed(2);
          this.orderSales.push(parseFloat(_a_))
          var _b_ = parseFloat(this.gDataList[i].order_amount).toFixed(2);
          this.orderDeal.push(parseFloat(_b_))
          this.dataTime.push(this.gDataList[i]._id)
        }
        var data1 = [
          {
            name: '订单总金额',
            type: 'line',
            label: "订单总金额",
            data: this.orderSales,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '订单总成交额',
            type: 'bar',
            label: "订单总成交额",
            data: this.orderDeal,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          }
        ]
        var data2 = [
          {
            name: '新增会员数量',
            type: 'bar',
            barGap: 0,
            label: "新增会员数量",
            data: this.member_add_number,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '新增医生数量',
            type: 'line',
            label: "新增医生数量",
            data: this.doctor_add_number,
            markPoint : {
              data : [
                {type : 'max', name: '最大值'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '新增患者数量',
            type: 'bar',
            label: "新增患者数量",
            data: this.patient_add_number,
            markPoint : {
              data : [
                {type : 'max', name: '最大值',color:'red'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '下单客户数',
            type: 'line',
            label: "下单客户数",
            data: this.placeNumber,
            markPoint : {
              data : [
                {type : 'max', name: '最大值',color:'red'},
                {type : 'min', name: '最小值'}
              ]
            }
          },
          {
            name: '新增门店数量',
            type: 'line',
            label: "新增门店数量",
            data: this.store_add_number,
            markPoint : {
              data : [
                {type : 'max', name: '最大值',color:'red'},
                {type : 'min', name: '最小值'}
              ]
            }
          }
        ]
        this.myChart_all.hideLoading();
        this.myChart_all.setOption(this.dataLine(data1,this.dataTime,['订单总金额','订单总成交额']),true);
        this.myChart_bottom.hideLoading();
        this.myChart_bottom.setOption(this.dataLine(data2,this.dataTime,['新增会员', '新增医生', '新增患者','下单数量', '新增门店数量']),true);
        this.myChartdivHeight.height = (window.innerHeight-18)/2+"px";
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.isAjax();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.isAjax();
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      excelData:async function () {
        await this.$axios.post('/data/excelRetailDayData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:this.time
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            location.href = response.data;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      dataLine(data,xdata,ldata){
        return {
          color: ['#87F7CF', '#FF4046', '#FC97AF', '#008000'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ldata
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          calculable: true,
          grid:{
            top:"50px",
            left:"50px",
            right:"15px",
            bottom:"50px"
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              data: xdata,
            }
          ],
          grid:{
            x: 90, //默认是80px
            y: 60, //默认是60px
            x2: 40, //默认80px
            y2: 60 //默认60px
          },
          yAxis: [
            {
              type: 'value',
              axisLabel: {
                formatter: function (value) {
                  value = value/10000;
                  return value+"万";
                }
              }
            }
          ],
          series: data
        }
      },
      qieFun: function () {
        this.$store.commit('setStoreNumtype', this.$store.getters.getStoreNumtype === 'NUM' ? 'CN' : 'NUM');
        this.isAjax()
      },
      isAjax:async function(){
        await this.$axios.post('/data/addRetailDayData',{
          d:this.dropdownTitle,
          s:this.serchat,
          t:this.time,
          "limit":this.count0,
          "page":this.currentPage0
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.gDataList = response.data[2];
            this.divHeight = window.innerHeight-108;
            if(this.checkNum == 1){
              this.graphicalBlock.display = 'none';
            }
            this.$nextTick (function () {
              this.showGraphical();
            })
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = 'N/A';
          }
          if (index === 9) {
            sums[index] = 'N/A';
          }else {
            sums[index] = parseFloat(sums[index]).toFixed(2);
            sums[index] = this.formatterAmount1(sums[index])
          }
        });
        return sums;
      }
    },
    mounted(){
      this.$store.dispatch('loadData');
      this.addClass();
      this.$echarts.registerTheme('purple-passion', PurplePassion)
      this.myChart_all = this.$echarts.init(document.getElementById('myChart_all'),'purple-passion')
      this.myChart_bottom = this.$echarts.init(document.getElementById('myChart_bottom'),'purple-passion')
      this.isAjax();
    }
  }
</script>
<style scoped>
  .el-main{
    overflow: hidden;
    padding: 0 !important;
    margin: 0 !important;
  }
  [v-cloak] {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/dataRetailStatistics/dayRetailData.vue